import { render, staticRenderFns } from "./sign_br_change.vue?vue&type=template&id=a80b12cc&"
import script from "./sign_br_change.vue?vue&type=script&lang=js&"
export * from "./sign_br_change.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports